import instance from 'shared/helpers/axios';
import { catchError } from 'shared/helpers/catchError';
import { ISupplierPrefixesResponse } from './types';

export const getSupplierPrefixes = async () => {
  try {
    const { data } = await instance.get<ISupplierPrefixesResponse>(
      '/dictionaries/supplier_prefixes',
    );
    return data;
  } catch (error) {
    catchError(error);
  }
};
